import ClassNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import { largeUp } from 'constants/mediaQueries';
import Theme from 'styles/theme';

const FilterPaneSection = ({ children, className }) => (
  <div className={ClassNames('FilterPaneSection', className)}>
    {children}
    <style jsx>{`
      .FilterPaneSection {
        padding-bottom: ${Theme.get('spacing')}px;
        margin-bottom: ${Theme.get('spacing') * 2.5}px;
        border-bottom: 1px solid ${Theme.get('colors-black-20')};
        padding-right: ${Theme.get('spacing') * 4}px;
      }

      @media ${largeUp} {
        .FilterPaneSection {
          padding-right: 0;
        }
      }
    `}</style>
  </div>
);

FilterPaneSection.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  className: PropTypes.string,
};

FilterPaneSection.defaultProps = {
  children: null,
  className: null,
};

export default FilterPaneSection;
